import { all, fork } from "redux-saga/effects";
import bankSaga from "../../views/bank/saga";
// import { fetchPaymentList } from "../../views/bank/saga";
// import bankSage from "../../views/bank/saga";

export default function* rootBankSaga() {
  // yield all([fork(fetchPaymentList())]);
  yield all([fork(bankSaga)]);

}